var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import * as contractActionsV2 from "../contract/contract.actions";
import * as rentRegistrationActions from "../rentRegistration/rentRegistration.actions";
import * as rentRegistrationApi from "../rentRegistration/rentRegistration.api";
import { mapDocument } from "../utils/registrationDocument.saga.utils";
import * as registrationDocumentAction from "./rentRegistrationDocuments.actions";
import * as registrationDocumentApi from "./rentRegistrationDocuments.api";
function getPagedRegistrationDocumentStartFlow(action) {
    var _a, query, onSuccess, onFailure, response, unknownError_1, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, query = _a.query, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(registrationDocumentApi.getPaged, { query: query })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(registrationDocumentAction.getPagedSucceeded.getAction({
                        query: query,
                        result: response.data,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _b.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(registrationDocumentAction.getPagedFailed.getAction({ query: query, error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getCountRegistrationDocumentStartFlow(action) {
    var _a, query, onSuccess, onFailure, response, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, query = _a.query, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(registrationDocumentApi.getCount, { query: query })];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, put(registrationDocumentAction.getCountSucceeded.getAction({
                        query: query,
                        result: response.data,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(registrationDocumentAction.getCountFailed.getAction({ query: query, error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function registrationAddDocumentsStartFlow(action) {
    var _a, registrationId, documents, registrationResponse, registration_1, mappedDocuments, fetchedResponse, fetchedRegistration, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, registrationId = _a.registrationId, documents = _a.documents;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 9, , 11]);
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registrationId })];
            case 2:
                registrationResponse = _b.sent();
                registration_1 = registrationResponse.data.data;
                return [4 /*yield*/, all(documents.map(function (document) {
                        return mapDocument({ registrationDocument: document, registration: registration_1 });
                    }))];
            case 3:
                mappedDocuments = _b.sent();
                return [4 /*yield*/, call(registrationDocumentApi.registrationAddDocuments, registration_1.id, mappedDocuments)];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registration_1.id })];
            case 5:
                fetchedResponse = _b.sent();
                fetchedRegistration = fetchedResponse.data.data;
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: fetchedRegistration.contractId,
                    }))];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(rentRegistrationActions.getDetailSucceeded.getAction({
                        id: registrationId,
                        result: fetchedResponse.data,
                    }))];
            case 7:
                _b.sent();
                return [4 /*yield*/, put(registrationDocumentAction.addRegistrationDocumentSucceeded.getAction({
                        registrationId: registrationId,
                        registration: fetchedRegistration,
                    }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 11];
            case 9:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(registrationDocumentAction.addRegistrationDocumentFailed.getAction({
                        registrationId: registrationId,
                        error: error,
                    }))];
            case 10:
                _b.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function registrationUpdateDocumentStartFlow(action) {
    var _a, registrationId, documentId, document, registrationResponse, registration, mappedDocument, fetchedResponse, fetchedRegistration, unknownError_4, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, registrationId = _a.registrationId, documentId = _a.documentId, document = _a.document;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 9, , 11]);
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registrationId })];
            case 2:
                registrationResponse = _b.sent();
                registration = registrationResponse.data.data;
                return [4 /*yield*/, call(mapDocument, {
                        registrationDocument: document,
                        registration: registration,
                    })];
            case 3:
                mappedDocument = _b.sent();
                return [4 /*yield*/, call(registrationDocumentApi.registrationUpdateDocuments, {
                        documentId: documentId,
                        registrationId: registration === null || registration === void 0 ? void 0 : registration.id,
                        data: mappedDocument,
                    })];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registration.id })];
            case 5:
                fetchedResponse = _b.sent();
                fetchedRegistration = fetchedResponse.data.data;
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: fetchedRegistration.contractId,
                    }))];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(rentRegistrationActions.getDetailSucceeded.getAction({
                        id: registrationId,
                        result: fetchedResponse.data,
                    }))];
            case 7:
                _b.sent();
                return [4 /*yield*/, put(registrationDocumentAction.updateRegistrationDocumentSucceeded.getAction({
                        registrationId: registrationId,
                        registration: fetchedRegistration,
                    }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 11];
            case 9:
                unknownError_4 = _b.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(registrationDocumentAction.updateRegistrationDocumentFailed.getAction({
                        registrationId: registrationId,
                        error: error,
                    }))];
            case 10:
                _b.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function registrationDeleteDocumentStartFlow(action) {
    var _a, registrationId, documentId, onSuccess, fetchedResponse, fetchedRegistration, unknownError_5, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, registrationId = _a.registrationId, documentId = _a.documentId, onSuccess = _a.onSuccess;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, call(registrationDocumentApi.registrationDeleteDocuments, documentId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, call(rentRegistrationApi.getDetail, { id: registrationId })];
            case 3:
                fetchedResponse = _b.sent();
                fetchedRegistration = fetchedResponse.data.data;
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: fetchedRegistration.contractId,
                    }))];
            case 4:
                _b.sent();
                return [4 /*yield*/, put(rentRegistrationActions.getDetailSucceeded.getAction({
                        id: registrationId,
                        result: fetchedResponse.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, put(registrationDocumentAction.deleteRegistrationDocumentSucceeded.getAction({
                        documentId: documentId,
                        registrationId: registrationId,
                    }))];
            case 6:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(registrationId);
                return [3 /*break*/, 9];
            case 7:
                unknownError_5 = _b.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    error: error,
                });
                return [4 /*yield*/, put(registrationDocumentAction.deleteRegistrationDocumentFailed.getAction({
                        documentId: documentId,
                        registrationId: registrationId,
                        error: error,
                    }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(registrationDocumentAction.getPagedStart.type, getPagedRegistrationDocumentStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(registrationDocumentAction.getCountStart.type, getCountRegistrationDocumentStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(registrationDocumentAction.addRegistrationDocumentStart.type, registrationAddDocumentsStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(registrationDocumentAction.updateRegistrationDocumentStart.type, registrationUpdateDocumentStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(registrationDocumentAction.deleteRegistrationDocumentStart.type, registrationDeleteDocumentStartFlow)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
